import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/api-services/user.service';
@Component({
  selector: 'app-need-cnfrm-dialog',
  templateUrl: './need-cnfrm-dialog.component.html',
  styleUrl: './need-cnfrm-dialog.component.scss'
})
export class NeedCnfrmDialogComponent {
  isLoading: boolean = false;
  isSending: boolean = false;
  tenant: any = localStorage.getItem('tenant');
  constructor(
    public dialogRef: MatDialogRef<NeedCnfrmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private userService: UserService

  ) { }

  dismiss() {
    this.dialogRef.close({ action: 'dismiss' });
  }

  sendToUnmatchedQueue() {
    const payload = {
      prescription_id: this.data.item.id,
      db_tenant: this.tenant.toUpperCase(),
    };
    this.isSending = true;
    this.userService.transfer_revert_fax_mapping(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.toastr.success(res.body.message);
          this.dialogRef.close(res?.body?.success);
        } else {
          this.toastr.error(res.body.message);
          this.dialogRef.close(res?.body?.success);
        }
      },
      error: (error: any) => {
        this.toastr.error(error.message || 'Failed to confirm match');
        this.dialogRef.close(false);
      }
    });
  }

  confirmMatch() {
    const payload = {
      db_tenant: this.tenant.toUpperCase(),
      message_id: this.data.item.rc_message_id,
      transper_prescription_id: this.data.item.id,
    };
    this.isLoading = true;
    this.userService.confirm_match_transfer(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.toastr.success(res.body.message);
          this.dialogRef.close(res?.body?.success);
        } else {
          this.toastr.error(res.body.message);
          this.dialogRef.close(res?.body?.success);
        }
      },
      error: (error: any) => {
        this.toastr.error(error.message || 'Failed to confirm match');
        this.dialogRef.close(false);
      }
    });
  }
}
